import { Plugin, PluginKey } from 'hubspot-prosemirror/pm/state';
import { setTrSelectionPosition } from '../utils/documentUtils';
const focusPluginKey = new PluginKey('FocusPlugin');
function isExternalEditableFocused(view, includeContentEditable) {
  // A root's `activeElement` only reports focus within its own tree, so descend
  // through any shadow roots to the element that actually holds focus.
  let active = view.dom.ownerDocument.activeElement;
  while ((_active = active) !== null && _active !== void 0 && (_active = _active.shadowRoot) !== null && _active !== void 0 && _active.activeElement) {
    var _active;
    active = active.shadowRoot.activeElement;
  }
  if (!active || view.dom.contains(active)) {
    return false;
  }
  const {
    tagName
  } = active;
  if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
    return true;
  }
  return includeContentEditable && active.isContentEditable === true;
}
export const FocusPlugin = new Plugin({
  key: focusPluginKey,
  state: {
    init() {
      return {};
    },
    apply(tr, currentPluginState) {
      const meta = tr.getMeta(FocusPlugin);
      if (meta) {
        return meta;
      }
      return currentPluginState;
    }
  },
  view() {
    return {
      update: view => {
        const pluginState = focusPluginKey.getState(view.state);
        if (pluginState && pluginState.focusView) {
          // only focus if it isn't currently focused
          window.requestAnimationFrame(() => {
            if (!view.dom.isConnected) {
              return;
            }
            const state = focusPluginKey.getState(view.state);
            if (!state || !state.focusView) {
              return;
            }
            focusEditorView(view, {
              focusViewPos: state.focusViewPos,
              preserveSelection: state.preserveSelection
            });
          });
        }
      }
    };
  }
});
export function focusEditorView(view, {
  focusViewPos,
  preserveSelection,
  respectExistingFocus
} = {}) {
  // Acting on a view that unmounted before this frame ran throws.
  if (!view.dom.isConnected) {
    return;
  }
  if (isExternalEditableFocused(view, Boolean(respectExistingFocus))) {
    var _focusPluginKey$getSt;
    // Focus is held elsewhere; don't steal it. Clear any armed intent.
    if ((_focusPluginKey$getSt = focusPluginKey.getState(view.state)) !== null && _focusPluginKey$getSt !== void 0 && _focusPluginKey$getSt.focusView) {
      view.dispatch(view.state.tr.setMeta(FocusPlugin, {}));
    }
    return;
  }
  if (!preserveSelection && view.hasFocus()) {
    var _focusPluginKey$getSt2;
    // Already focused, so this request is a no-op. Consume it; leaving it
    // armed makes the next blur (a pop-up menu) look like a new request.
    if ((_focusPluginKey$getSt2 = focusPluginKey.getState(view.state)) !== null && _focusPluginKey$getSt2 !== void 0 && _focusPluginKey$getSt2.focusView) {
      view.dispatch(view.state.tr.setMeta(FocusPlugin, {}));
    }
    return;
  }
  if (!view.hasFocus()) {
    view.focus();
  }
  const tr = preserveSelection ? view.state.tr : setTrSelectionPosition(view.state.tr, focusViewPos);
  view.dispatch(tr.setMeta(FocusPlugin, {}));
}